import { Box } from "../Box";
import React from "react";
import AsphaltDatePicker, {
  AsphaltDatePickerProps,
} from "@asphalt-react/date-picker";
import { InputLabel } from "../Input";
import { Text } from "../Text";

type Props = {
  label?: React.ReactNode;
  helperText?: string;
  error?: boolean;
} & AsphaltDatePickerProps;

export const DatePicker = (props: Props) => {
  const { label, helperText, error, ...asphaltProps } = props;

  return (
    <Box>
      {label && <InputLabel>{label}</InputLabel>}
      <AsphaltDatePicker {...asphaltProps} invalid={error} />
      {helperText && (
        <Text
          marginTopS
          fontSize="small"
          color={error ? "danger" : undefined}
          fontWeight="book"
        >
          {helperText}
        </Text>
      )}
    </Box>
  );
};
